import { Badge } from '@/components/ui/badge'
import { GridCellProps, GridColumnProps } from '@progress/kendo-react-grid'

import { NotificationDto, NotificationDtoKey } from '../../../api/Clients/Types/NotificationDto'
import { formatLocalDateUTC } from '../../../utils/date'

export interface GridColumn extends GridColumnProps {
  show: boolean
  width?: number
}

export const marketingNotificationsColumns: GridColumn[] = [
  {
    title: 'Type',
    field: NotificationDtoKey.type,
    cell: (props: GridCellProps) => {
      if (!props.dataItem?.notificationType?.name) {
        return <td />
      }

      return <td>{props.dataItem.notificationType.name}</td>
    },
    width: 200,
    show: true,
  },
  {
    title: 'Enabled',
    field: NotificationDtoKey.enabled,
    cell: (props: GridCellProps) => {
      const notification = props.dataItem as NotificationDto

      if (notification?.isEnabled === undefined) {
        return <td />
      }

      return (
        <td>
          <Badge variant={notification.isEnabled ? 'green' : 'destructive'}>
            {notification.isEnabled ? 'Yes' : 'No'}
          </Badge>
        </td>
      )
    },
    show: true,
    width: 150,
  },
  {
    title: 'Start Date',
    field: NotificationDtoKey.startDateTime,
    cell: (props: GridCellProps) => {
      if (!props.dataItem?.startDateTime) {
        return <td />
      }

      return (
        <td className='transaction-columns__date'>
          {formatLocalDateUTC(props.dataItem.startDateTime, true)}
        </td>
      )
    },
    show: true,
    width: 150,
  },
  {
    title: 'End Date',
    field: NotificationDtoKey.endDateTime,
    cell: (props: GridCellProps) => {
      if (!props.dataItem?.endDateTime) {
        return <td />
      }

      return (
        <td className='transaction-columns__date'>
          {formatLocalDateUTC(props.dataItem.endDateTime, true)}
        </td>
      )
    },
    show: true,
    width: 150,
  },
]
